export default __webpack_public_path__ + "static/media/h1.1555a011.webp";